<div class="gdi-modal" (click)="close.emit()" *ngIf="_open" trapFocus>
    <div class="gdi-modal-wrapper" (click)="preventClose($event)">
        <ng-content></ng-content>
    </div>
</div>
